import { useApolloClient } from '@apollo/client';
import { INSERT_VENDOR_NOTIFICATION } from 'Util/mutations';
import _ from 'lodash';

/**
 * Custom hook for adding notifications to the database
 */
export const useNotifications = () => {
  const client = useApolloClient();

    /**
   * Add notification for specific users
   */
    const addNotificationForUsers = async (users, { title, body, type }) => {
        try {
          const userNotificationData = users.map((u) => ({
            user_id: u.id,
            subject: title,
            body,
            type,
          }));
    
          await client.mutate({
            mutation: INSERT_VENDOR_NOTIFICATION,
            variables: { objects: userNotificationData },
          });
    
        } catch (error) {
          console.error('Error inserting user notifications:', error);
        }
      };

  /**
   * Add notifications for all users
   */
//   const addNotificationForAllUsers = async ({ title, body }) => {
//     try {
//       const { data } = await client.query({ query: NOTIFICATION_USERS });

//       if (!_.isEmpty(data) && data.users) {
//         const { users } = data;

//         // Prepare notification entries
//         const userNotificationData = users.map((u) => ({
//           user_id: u.id,
//           subject: title,
//           body,
//           type: 'alert',
//         }));

//         // Insert notifications
//         await client.mutate({
//           mutation: INSERT_NOTIFICATION,
//           variables: { data: userNotificationData },
//         });

//         console.log('Notifications successfully inserted for all users.');
//       } else {
//         console.warn('No users found for notification.');
//       }
//     } catch (error) {
//       console.error('Error inserting notifications:', error);
//     }
//   };

  return { addNotificationForUsers };
};
